import { render } from "./iframe.vue?vue&type=template&id=28f608a2&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"

import "./iframe.vue?vue&type=style&index=0&id=28f608a2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-28f608a2"

export default script